export default class BaseStore {
  constructor(rootStore) {
    this.rootStore = rootStore;
  }
}